import { axiosGet, axiosPost } from "../../react_axios/Axios"
import { CREDIT_NOTE_DELETE_ACTION_TYPE, CREDIT_NOTE_DETAILS_ACTION_TYPE, CREDIT_NOTE_DETAILS_ORDER_ACTION_TYPE, CREDIT_NOTE_DOWNLOAD_ACTION_TYPE, CREDIT_NOTE_IE_ACTION_TYPE, CREDIT_NOTE_LIST_ACTION_TYPE, creditNoteDetailsOrderUrl, creditNoteDetailsUrl, creditNoteListUrl, creditNoteRPT, deleteCreditNoteUrl, fetchReport, headers, insertEditCreditNoteUrl } from "../../utils/constants"
import moment from 'moment';

export const credit_note_list_action =
  ( CreditNoteNo, FromDate,ToDate, CompanyName, StatusID) =>
  async (dispatch) => {
    try {
      const mapdata = {
        userId:
          sessionStorage.getItem("userId") == "" ||
          sessionStorage.getItem("userId") == null
            ? ""
            : sessionStorage.getItem("userId"),
        CreditNoteNo: CreditNoteNo.toString().trim(),
        FromDate: FromDate
          ? moment(FromDate).format("YYYY-MM-DD")
          : null,
          ToDate: ToDate
          ? moment(ToDate).format("YYYY-MM-DD")
          : null,
        CompanyName: CompanyName.toString().trim(),
        StatusID: StatusID.toString().trim(),
      };
      const params = {
        userId: mapdata.userId === "" ? null : mapdata.userId,
        CreditNoteNo: mapdata.CreditNoteNo === "" ? null : mapdata.CreditNoteNo,
        FromDate: FromDate
          ? moment(FromDate).format("YYYY-MM-DD")
          : null,
          ToDate: ToDate
          ? moment(ToDate).format("YYYY-MM-DD")
          : null,
        CompanyName: mapdata.CompanyName,
        StatusID: mapdata.StatusID,
      };
      console.log("creditNote mapdata...", mapdata);
      const res = await axiosGet(creditNoteListUrl, params,headers);
      console.log("creditNote", res);
      dispatch({
        type: CREDIT_NOTE_LIST_ACTION_TYPE,
        payload: res,
      });
      return res; // No need to wrap in Promise.resolve()
    } catch (err) {
      return Promise.reject(err);
    }
  };

export const credit_note_detail_order_action =
  (userId, OrderID) => async (dispatch) => {
    try {
      const params = {
        userId:
          sessionStorage.getItem("userId") == "" ||
          sessionStorage.getItem("userId") == null
            ? ""
            : sessionStorage.getItem("userId"),
        OrderID: OrderID,
      };
      console.log("creditNote detail mapdata...", params);
      const res = await axiosGet(creditNoteDetailsOrderUrl, params,headers);
      console.log("detailscreditNote", res);
      dispatch({
        type: CREDIT_NOTE_DETAILS_ORDER_ACTION_TYPE,
        payload: res,
      });
      return res; // No need to wrap in Promise.resolve()
    } catch (err) {
      return Promise.reject(err);
    }
  };

export const credit_note_detail_action =
  (userId, CreditNoteID) => async (dispatch) => {
    try {
      const params = {
        userId:
          sessionStorage.getItem("userId") == "" ||
          sessionStorage.getItem("userId") == null
            ? ""
            : sessionStorage.getItem("userId"),
        CreditNoteID: CreditNoteID ? CreditNoteID.toString().trim() : "",
      };
      console.log("creditNote detail mapdata...", params);
      const res = await axiosGet(creditNoteDetailsUrl, params,headers);
      console.log("detailscreditNote RES", res);
      dispatch({
        type: CREDIT_NOTE_DETAILS_ACTION_TYPE,
        payload: res,
      });
      return res; // No need to wrap in Promise.resolve()
    } catch (err) {
      return Promise.reject(err);
    }
  };

export const credit_note_add_action =
  (
    userId,
    CreditNoteID,
    CreditNoteNo,
    CreditNoteDate,
    OrderNo,
    CompanyName,
    Address,
    GSTNo,
    CurrencyID,
    Remark,
    udtList,
    OrderID,
    ClientID,PrimaryEmailID
  ) =>
  async (dispatch) => {
    try {
      const mapdata = {
        userId:
          sessionStorage.getItem("userId") == "" ||
          sessionStorage.getItem("userId") == null
            ? ""
            : sessionStorage.getItem("userId"),
            CreditNoteID:CreditNoteID?CreditNoteID:"",
        CreditNoteNo: CreditNoteNo?CreditNoteNo:"",
        CreditNoteDate:CreditNoteDate? moment(CreditNoteDate, 'DD-MM-YYYY').format('YYYY-MM-DD'):"",
        OrderNo: OrderNo ? OrderNo : "",
        CompanyName: CompanyName,
        Address: Address,
        GSTNo: GSTNo,
        CurrencyID: CurrencyID,
        Remark:Remark,
        udtList:udtList,
        OrderID: OrderID,
        ClientID:ClientID,
        PrimaryEmailID:PrimaryEmailID
      };
      console.log("creditNote add mapdata...", mapdata);

      const res = await axiosPost(insertEditCreditNoteUrl, mapdata, headers);
      dispatch({
        type: CREDIT_NOTE_IE_ACTION_TYPE,
        payload: res,
      });
      return Promise.resolve(res);
    } catch (err) {
      return Promise.reject(err);
    }
  };

export const credit_note_delete_action =
  ( CreditNoteID) => async (dispatch) => {
    try {
      const mapdata = {
        userId:
          sessionStorage.getItem("userId") == "" ||
          sessionStorage.getItem("userId") == null
            ? ""
            : sessionStorage.getItem("userId"),
        CreditNoteID: CreditNoteID ? CreditNoteID.toString().trim() : "",
      };

      const res = await axiosGet(deleteCreditNoteUrl, mapdata,headers);
      dispatch({
        type: CREDIT_NOTE_DELETE_ACTION_TYPE,
        payload: res,
      });
      return Promise.resolve(res);
    } catch (err) {
      return Promise.reject(err);
    }
  };
  export const download_creditNote_action = (userId, CreditNoteID,CreditNoteNo) => async (dispatch) => {
    try {
      var list = [];
      const mapdata1 = {
        ParameterName: "@CreditNoteID",
        ParameterValue: CreditNoteID,
        ParameterDataType: "int",
      };
      list.push(mapdata1);
      console.log("mapdata1", mapdata1, list);
  
      const mapData = {
        user_id: userId,
        report_name: creditNoteRPT,
        report_file_name: CreditNoteNo,
        config_id: 0,
        parameter_details: list,
      };
      console.log(mapData);
      const res = await axiosPost(fetchReport, mapData, headers);
  
      dispatch({
        type: CREDIT_NOTE_DOWNLOAD_ACTION_TYPE,
        payload: res,
      });
  
      return Promise.resolve(res);
    } catch (err) {
      return Promise.reject(err);
    }
  };